import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=2712d094&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"
import style0 from "./login.css?vue&type=style&index=0&id=2712d094&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712d094",
  null
  
)

export default component.exports